import apolloWrapper from '@hoc/apolloWrapper';
import {
  getDebtLevelFromCache,
  cacheDebtLevel,
} from '@utils/cache';
import {
  DebtWarning,
  themes,
} from '@components/DebtWarning';
import { DebtLevels } from '@models';

import { useDebtWarningQuery } from './queries/graphql.v3.generated';

// styles
import s from './DebtWarning.sss';

// consts
const debtLevelTheme: DebtLevelThemesType = {
  [DebtLevels.Critical]: 'red',
};

// types
type DebtLevelThemesType = Partial<Record<DebtLevels, keyof typeof themes>>;

export const DebtWarningContainer: React.FC = () => {
  let data = getDebtLevelFromCache();
  if (!data) {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react-hooks/rules-of-hooks
    data = useDebtWarningQuery({
      context: { batch: true },
    }).data;

    if (data) {
      cacheDebtLevel(data);
    }
  }

  if (data && data.viewer && data.viewer.debtLevel) {
    const {
      balance,
      debtLevel,
    } = data.viewer;
    const warningTheme = debtLevelTheme[debtLevel];

    if (warningTheme !== undefined) {
      return (
        <DebtWarning
          className={s.warning}
          balance={balance}
          theme={warningTheme}
        />
      );
    }
  }

  return null;
};

export default apolloWrapper(DebtWarningContainer);
